// extracted by mini-css-extract-plugin
export default {"wrapper":"UsersByNutrition_wrapper__7ZGRT","tableWrap":"UsersByNutrition_tableWrap__qduan"};